/** Cost of the next +1, matching the original C++ server's pakAddStats formula. */
export function getStatPointCost(currentValue: number): number {
    return Math.floor(currentValue / 5);
}
